module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/google_business-0abfbc9b646bbe04b3f75bb02a22a3ca.png";